import useSWR from "swr";
import { Utils } from "@/common/utils";
import { Student, TableParams } from "Stores/commonStore";
import { EAIClient } from "Services/EAIClient";
const clientConfigs = Utils.getEAIClientConfigs();

type StudentsAtRisk = {
    examsoft1: number
    examsoft2: number
    canvas: number
}

type StudentsAtRiskResponse = {
    data: StudentsAtRisk
}
interface getStudentsResponse {
    data: Student[];
    total_count: number;
}


export function useStudentsAtRisk() {
    const { data, error, mutate, isLoading } = useSWR<StudentsAtRiskResponse, Error>(`${clientConfigs.endpoint}/schools/${clientConfigs.school}/students/at-risk`);

    return {
        data,
        error,
        mutate,
        isLoading
    };
}


export function useGetStudents(tableParams?: TableParams, timestamp?: number) {
    const eaiClient = new EAIClient()
    const params = {};

    if (tableParams) {
        const { dashboardId, pageSize, page, sortBy, sortOrder, filters, include_disabled } = tableParams;

        if (timestamp) params["timestamp"] = timestamp;
        if (dashboardId) params["dashboard_id"] = dashboardId;
        if (pageSize) params["page_size"] = pageSize;
        if (page) params["page"] = page;
        if (sortBy) params["sort"] = sortBy;
        if (sortOrder) params["sort_order"] = sortOrder;
        if (filters) params["filters"] = JSON.stringify(filters);
        if (include_disabled) params["include_disabled"] = include_disabled;
    }

    const queryParams = eaiClient.generateQueryParams(params);

    const { data, error, isLoading } = useSWR<getStudentsResponse, Error>(`${clientConfigs.endpoint}/schools/${clientConfigs.school}/students/${queryParams}`)

    return {
        data, error, isLoading
    }
}